import { AcquireTokenAuthError } from '../errors';

const adalThirdPartyCookieErrorMessagePrefix = 'AADSTS50058';

type IsAdalThirdPartyCookieError = (error: unknown) => boolean;
export const isAdalThirdPartyCookieError: IsAdalThirdPartyCookieError = (error) =>
  error instanceof AcquireTokenAuthError && error.errorMessage.includes(adalThirdPartyCookieErrorMessagePrefix);
